import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import '../../styles/index.css';

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { user, refreshUserProfile } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (newPassword.length < 6) {
            setError('Password must be at least 6 characters long');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (newPassword === 'Scholar@123') {
            setError('Please choose a different password than the default');
            return;
        }

        setLoading(true);

        try {
            await api.post('/auth/change-password', { newPassword });

            // Refresh user profile to update mustChangePassword flag
            if (refreshUserProfile) {
                await refreshUserProfile();
            }

            // Redirect based on role
            switch (user?.role) {
                case 'scholar':
                    navigate('/scholar/dashboard');
                    break;
                case 'supervisor':
                    navigate('/supervisor/dashboard');
                    break;
                case 'dlc':
                    navigate('/dlc/dashboard');
                    break;
                case 'hod':
                    navigate('/hod/dashboard');
                    break;
                case 'dean':
                    navigate('/dean/dashboard');
                    break;
                case 'admin':
                    navigate('/admin/dashboard');
                    break;
                default:
                    navigate('/');
            }
        } catch (err) {
            console.error('Password change error:', err);
            setError(err.response?.data?.message || 'Failed to change password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                background: 'white',
                padding: '3rem',
                borderRadius: '1rem',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                width: '100%',
                maxWidth: '450px'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        background: '#fef3c7',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1rem'
                    }}>
                        <span style={{ fontSize: '1.5rem' }}>🔐</span>
                    </div>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>
                        Change Your Password
                    </h1>
                    <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                        For security, please set a new password for your account.
                    </p>
                </div>

                {error && (
                    <div style={{
                        background: '#fee2e2',
                        color: '#991b1b',
                        padding: '0.75rem',
                        borderRadius: '0.5rem',
                        marginBottom: '1.5rem',
                        fontSize: '0.875rem'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-input"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            minLength={6}
                            placeholder="Enter new password (min 6 characters)"
                            style={{ padding: '0.75rem' }}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Confirm New Password</label>
                        <input
                            type="password"
                            className="form-input"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            minLength={6}
                            placeholder="Confirm new password"
                            style={{ padding: '0.75rem' }}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                        style={{ width: '100%', padding: '0.75rem', fontSize: '1rem', marginTop: '1rem' }}
                    >
                        {loading ? 'Changing Password...' : 'Set New Password'}
                    </button>
                </form>

                <div style={{
                    marginTop: '1.5rem',
                    padding: '1rem',
                    background: '#f0fdf4',
                    borderRadius: '0.5rem',
                    border: '1px solid #bbf7d0'
                }}>
                    <p style={{ fontSize: '0.75rem', color: '#166534', margin: 0, fontWeight: '500' }}>
                        Password Requirements:
                    </p>
                    <ul style={{ fontSize: '0.75rem', color: '#166534', margin: '0.5rem 0 0 1rem', padding: 0 }}>
                        <li>At least 6 characters long</li>
                        <li>Must have at least one uppercase letter</li>
                        <li>Must have at least one lowercase letter</li>
                        <li>Must have at least one number</li>
                        <li>Must have at least one special character</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
